export default "__VITE_ASSET__50fd8cd5__"